import { createContext } from 'react';

const initialState = [];
export const AdviceContext = createContext(initialState);
